export const DEFAULT_LANGUAGE = 'lang: en';
export const ROW_HEIGHT = 50;
export const HIGHLIGHT_COLOR = 'bg-primary';
export const STATUS_PREPARATION = 'intl-msg:translations.preparation'; // translation value
export const STATUS_DONE = 'intl-msg:translations.done'; // translation value
export const DEFAULT_CATEGORY = 'axisLevel';
export const LOCAL_STORAGE_KEY = {
    TRANSLATIONS: 'translations',
    INIT_TRANSLATIONS: 'initTranslations',
    SELECTED_LANGUAGES: 'selectedLanguages',
};
export const MERGE_STATUS = {
    NOTSTARTED: 'notStarted',
    RUNNING: 'running',
    FINISHED: 'finished',
    // ABORTED: 'aborted',
    // ERROR: 'error',
};
export const MERGE_STATUS_LABEL = {
    MISSING: 'missing',
    EXTRA: 'extra',
    NULL: 'null',
};
export const AUTOSAVED_BACKUP_TRANSLATIONS = 'AUTOSAVED_BACKUP_TRANSLATIONS';
export const EVENT_BEFOREUNLOAD = 'beforeunload';
export const PATH_TRANSLATIONS = '/translations';
export const CAUSE_REFRESHCLOSE = 'refresh/close';
export const CAUSE_ROUTECHANGE = 'route change';
export const FILETYPE_JSON = 'json';
export const LANGUAGE_COUNTRY = {
    'lang: af': 'af', //Afghanistan
    'lang: ax': 'ax', //Aland Islands
    'lang: al': 'al', //Albania
    'lang: dz': 'dz', //Algeria
    'lang: as': 'as', //American Samoa
    'lang: ad': 'ad', //Andorra
    'lang: ao': 'ao', //Angola
    'lang: ai': 'ai', //Anguilla
    'lang: aq': 'aq', //Antarctica
    'lang: ag': 'ag', //Antigua and Barbuda
    'lang: ar': 'ar', //Argentina
    'lang: am': 'am', //Armenia
    'lang: aw': 'aw', //Aruba
    'lang: au': 'au', //Australia
    'lang: at': 'at', //Austria
    'lang: az': 'az', //Azerbaijan
    'lang: bs': 'bs', //Bahamas
    'lang: bh': 'bh', //Bahrain
    'lang: bd': 'bd', //Bangladesh
    'lang: bb': 'bb', //Barbados
    'lang: by': 'by', //Belarus
    'lang: be': 'be', //Belgium
    'lang: bz': 'bz', //Belize
    'lang: bj': 'bj', //Benin
    'lang: bm': 'bm', //Bermuda
    'lang: bt': 'bt', //Bhutan
    'lang: bo': 'bo', //Bolivia
    'lang: bq': 'bq', //Bonaire, Sint Eustatius and Saba
    'lang: ba': 'ba', //Bosnia and Herzegovina
    'lang: bw': 'bw', //Botswana
    'lang: bv': 'bv', //Bouvet Island
    'lang: br': 'br', //Brazil
    'lang: io': 'io', //British Indian Ocean Territory
    'lang: bn': 'bn', //Brunei Darussalam
    'lang: bg': 'bg', //Bulgaria
    'lang: bf': 'bf', //Burkina Faso
    'lang: bi': 'bi', //Burundi
    'lang: cv': 'cv', //Cabo Verde
    'lang: kh': 'kh', //Cambodia
    'lang: cm': 'cm', //Cameroon
    'lang: ca': 'ca', //Canada
    'lang: ky': 'ky', //Cayman Islands
    'lang: cf': 'cf', //Central African Republic
    'lang: td': 'td', //Chad
    'lang: cl': 'cl', //Chile
    'lang: cn': 'cn', //China
    'lang: cx': 'cx', //Christmas Island
    'lang: cc': 'cc', //Cocos(Keeling) Islands
    'lang: co': 'co', //Colombia
    'lang: km': 'km', //Comoros
    'lang: ck': 'ck', //Cook Islands
    'lang: cr': 'cr', //Costa Rica
    'lang: ci': 'ci', //Côte d'Ivoire
    'lang: hr': 'hr', //Croatia
    'lang: cu': 'cu', //Cuba
    'lang: cw': 'cw', //Curaçao',
    'lang: cy': 'cy', //Cyprus
    'lang: cz': 'cz', //Czech Republic
    'lang: cd': 'cd', //Democratic Republic of the Congo
    'lang: dk': 'dk', //Denmark
    'lang: dj': 'dj', //Djibouti
    'lang: dm': 'dm', //Dominica
    'lang: do': 'do', //Dominican Republic
    'lang: ec': 'ec', //Ecuador
    'lang: eg': 'eg', //Egypt
    'lang: sv': 'sv', //El Salvador
    'lang: gq': 'gq', //Equatorial Guinea
    'lang: er': 'er', //Eritrea
    'lang: ee': 'ee', //Estonia
    'lang: sz': 'sz', //Eswatini
    'lang: et': 'et', //Ethiopia
    'lang: fk': 'fk', //Falkland Islands
    'lang: fo': 'fo', //Faroe Islands
    'lang: fm': 'fm', //Federated States of Micronesia
    'lang: fj': 'fj', //Fiji
    'lang: fi': 'fi', //Finland
    'lang: fr': 'fr', //France
    'lang: gf': 'gf', //French Guiana
    'lang: pf': 'pf', //French Polynesia
    'lang: tf': 'tf', //French Southern Territories
    'lang: ga': 'ga', //Gabon
    'lang: gm': 'gm', //Gambia
    'lang: ge': 'ge', //Georgia
    'lang: de': 'de', //Germany
    'lang: gh': 'gh', //Ghana
    'lang: gi': 'gi', //Gibraltar
    'lang: gr': 'gr', //Greece
    'lang: gl': 'gl', //Greenland
    'lang: gd': 'gd', //Grenada
    'lang: gp': 'gp', //Guadeloupe
    'lang: gu': 'gu', //Guam
    'lang: gt': 'gt', //Guatemala
    'lang: gg': 'gg', //Guernsey
    'lang: gn': 'gn', //Guinea
    'lang: gw': 'gw', //Guinea-Bissau
    'lang: gy': 'gy', //Guyana
    'lang: ht': 'ht', //Haiti
    'lang: hm': 'hm', //Heard Island and McDonald Islands
    'lang: va': 'va', //Holy See
    'lang: hn': 'hn', //Honduras
    'lang: hk': 'hk', //Hong Kong
    'lang: hu': 'hu', //Hungary
    'lang: is': 'is', //Iceland
    'lang: in': 'in', //India
    'lang: id': 'id', //Indonesia
    'lang: ir': 'ir', //Iran
    'lang: iq': 'iq', //Iraq
    'lang: ie': 'ie', //Ireland
    'lang: im': 'im', //Isle of Man
    'lang: il': 'il', //Israel
    'lang: it': 'it', //Italy
    'lang: jm': 'jm', //Jamaica
    'lang: jp': 'jp', //Japan
    'lang: je': 'je', //Jersey
    'lang: jo': 'jo', //Jordan
    'lang: kz': 'kz', //Kazakhstan
    'lang: ke': 'ke', //Kenya
    'lang: ki': 'ki', //Kiribati
    'lang: kw': 'kw', //Kuwait
    'lang: kg': 'kg', //Kyrgyzstan
    'lang: la': 'la', //Laos
    'lang: lv': 'lv', //Latvia
    'lang: lb': 'lb', //Lebanon
    'lang: ls': 'ls', //Lesotho
    'lang: lr': 'lr', //Liberia
    'lang: ly': 'ly', //Libya
    'lang: li': 'li', //Liechtenstein
    'lang: lt': 'lt', //Lithuania
    'lang: lu': 'lu', //Luxembourg
    'lang: mo': 'mo', //Macau
    'lang: mg': 'mg', //Madagascar
    'lang: mw': 'mw', //Malawi
    'lang: my': 'my', //Malaysia
    'lang: mv': 'mv', //Maldives
    'lang: ml': 'ml', //Mali
    'lang: mt': 'mt', //Malta
    'lang: mh': 'mh', //Marshall Islands
    'lang: mq': 'mq', //Martinique
    'lang: mr': 'mr', //Mauritania
    'lang: mu': 'mu', //Mauritius
    'lang: yt': 'yt', //Mayotte
    'lang: mx': 'mx', //Mexico
    'lang: md': 'md', //Moldova
    'lang: mc': 'mc', //Monaco
    'lang: mn': 'mn', //Mongolia
    'lang: me': 'me', //Montenegro
    'lang: ms': 'ms', //Montserrat
    'lang: ma': 'ma', //Morocco
    'lang: mz': 'mz', //Mozambique
    'lang: mm': 'mm', //Myanmar
    'lang: na': 'na', //Namibia
    'lang: nr': 'nr', //Nauru
    'lang: np': 'np', //Nepal
    'lang: nl': 'nl', //Netherlands
    'lang: nc': 'nc', //New Caledonia
    'lang: nz': 'nz', //New Zealand
    'lang: ni': 'ni', //Nicaragua
    'lang: ne': 'ne', //Niger
    'lang: ng': 'ng', //Nigeria
    'lang: nu': 'nu', //Niue
    'lang: nf': 'nf', //Norfolk Island
    'lang: kp': 'kp', //North Korea
    'lang: mk': 'mk', //North Macedonia
    'lang: mp': 'mp', //Northern Mariana Islands
    'lang: no': 'no', //Norway
    'lang: om': 'om', //Oman
    'lang: pk': 'pk', //Pakistan
    'lang: pw': 'pw', //Palau
    'lang: pa': 'pa', //Panama
    'lang: pg': 'pg', //Papua New Guinea
    'lang: py': 'py', //Paraguay
    'lang: pe': 'pe', //Peru
    'lang: ph': 'ph', //Philippines
    'lang: pn': 'pn', //Pitcairn
    'lang: pl': 'pl', //Poland
    'lang: pt': 'pt', //Portugal
    'lang: pr': 'pr', //Puerto Rico
    'lang: qa': 'qa', //Qatar
    'lang: cg': 'cg', //Republic of the Congo
    'lang: re': 're', //Réunion
    'lang: ro': 'ro', //Romania
    'lang: ru': 'ru', //Russia
    'lang: rw': 'rw', //Rwanda
    'lang: bl': 'bl', //Saint Barthélemy
    'lang: sh': 'sh', //Saint Helena, Ascension and Tristan da Cunha
    'lang: kn': 'kn', //Saint Kitts and Nevis
    'lang: lc': 'lc', //Saint Lucia
    'lang: mf': 'mf', //Saint Martin
    'lang: pm': 'pm', //Saint Pierre and Miquelon
    'lang: vc': 'vc', //Saint Vincent and the Grenadines
    'lang: ws': 'ws', //Samoa
    'lang: sm': 'sm', //San Marino
    'lang: st': 'st', //Sao Tome and Principe
    'lang: sa': 'sa', //Saudi Arabia
    'lang: sn': 'sn', //Senegal
    'lang: rs': 'rs', //Serbia
    'lang: sc': 'sc', //Seychelles
    'lang: sl': 'sl', //Sierra Leone
    'lang: sg': 'sg', //Singapore
    'lang: sx': 'sx', //Sint Maarten
    'lang: sk': 'sk', //Slovakia
    'lang: si': 'si', //Slovenia
    'lang: sb': 'sb', //Solomon Islands
    'lang: so': 'so', //Somalia
    'lang: za': 'za', //South Africa
    'lang: gs': 'gs', //South Georgia and the South Sandwich Islands
    'lang: kr': 'kr', //South Korea
    'lang: ss': 'ss', //South Sudan
    'lang: es': 'es', //Spain
    'lang: lk': 'lk', //Sri Lanka
    'lang: ps': 'ps', //State of Palestine
    'lang: sd': 'sd', //Sudan
    'lang: sr': 'sr', //Suriname
    'lang: sj': 'sj', //Svalbard and Jan Mayen
    'lang: se': 'se', //Sweden
    'lang: ch': 'ch', //Switzerland
    'lang: sy': 'sy', //Syria
    'lang: tw': 'tw', //Taiwan
    'lang: tj': 'tj', //Tajikistan
    'lang: tz': 'tz', //Tanzania
    'lang: th': 'th', //Thailand
    'lang: tl': 'tl', //Timor-Leste
    'lang: tg': 'tg', //Togo
    'lang: tk': 'tk', //Tokelau
    'lang: to': 'to', //Tonga
    'lang: tt': 'tt', //Trinidad and Tobago
    'lang: tn': 'tn', //Tunisia
    'lang: tr': 'tr', //Türkiye
    'lang: tm': 'tm', //Turkmenistan
    'lang: tc': 'tc', //Turks and Caicos Islands
    'lang: tv': 'tv', //Tuvalu
    'lang: ug': 'ug', //Uganda
    'lang: ua': 'ua', //Ukraine
    'lang: ae': 'ae', //United Arab Emirates
    'lang: en': 'gb', //United Kingdom
    'lang: um': 'um', //United States Minor Outlying Islands
    'lang: us': 'us', //United States of America
    'lang: uy': 'uy', //Uruguay
    'lang: uz': 'uz', //Uzbekistan
    'lang: vu': 'vu', //Vanuatu
    'lang: ve': 've', //Venezuela
    'lang: vn': 'vn', //Vietnam
    'lang: vg': 'vg', //Virgin Islands (British)
    'lang: vi': 'vi', //Virgin Islands (U.S.)
    'lang: wf': 'wf', //Wallis and Futuna
    'lang: eh': 'eh', //Western Sahara
    'lang: ye': 'ye', //Yemen
    'lang: zm': 'zm', //Zambia
    'lang: zw': 'zw', //Zimbabwe
};
